"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var Commands;
(function (Commands) {
    Commands["SIGNIN"] = "SIGNIN";
    Commands["SIGNOUT"] = "SIGNOUT";
})(Commands || (Commands = {}));
var authChannel = new BroadcastChannel('auth');
var commandFunctionsMap = (_a = {},
    _a[Commands.SIGNIN] = function (config, token) {
        try {
            localStorage.setItem(config.key, token);
        }
        catch (e) {
            console.error("[AUTH MANAGER] Unable to save token " + token, e);
        }
    },
    _a[Commands.SIGNOUT] = function (config) {
        localStorage.removeItem(config.key);
    },
    _a);
exports.init = function (config, fn) {
    authChannel.onmessage = function (e) {
        if (commandFunctionsMap[e.data.cmd] instanceof Function) {
            commandFunctionsMap[e.data.cmd](config, e.data.token);
        }
        if (fn) {
            fn(e.data.cmd);
        }
    };
};
exports.onSignIn = function (token) {
    return authChannel.postMessage({ cmd: Commands.SIGNIN, token: token });
};
exports.onSignOut = function () {
    return authChannel.postMessage({ cmd: Commands.SIGNOUT });
};
// TODO Make sure we implement a secure process to verify user session status
exports.isSignedIn = function (key) { return !!localStorage.getItem(key); };
//# sourceMappingURL=authManager.js.map